// written in jQuery because Foundation has no vanilla JS support
$(document).ready(function () {
	$('[data-accordion]').on('down.zf.accordion', function (event, accordion) {
		var currentItem = $(this);

		$('[data-accordion]')
			.not(currentItem)
			.each(function () {
				$(this).foundation('up', $(this).find('.accordion-content'));
			});
	});
});
